/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

import {
  Component,
  OnInit,
  ViewEncapsulation,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { SPLASH_SETTINGS } from './models/splash-page-consts';
import { Router } from '@angular/router';

/**
 * Component for loader page. This component is a unique component as it's stylesheet overrides the root application in
 * order-management to provide a loader screen. The state of this component is based upon any pre warming or prior
 * requests before the we load the application.
 * @access protected - used by the Root module
 */
@Component({
  selector: 'tmo-splash-page',
  encapsulation: ViewEncapsulation.None, // allows for root.component.scss to insert global styles
  templateUrl: './splash-page.component.html',
  styleUrls: ['../../../../../style-sheets/theme/splash-page.sass'],
})
export class SplashPageComponent implements OnInit, OnDestroy {
  @Output() public loadingComplete: EventEmitter<boolean>;
  /**
   * Stores numeric value for the percent
   */
  public percent: number;

  constructor(private router: Router) {
    this.loadingComplete = new EventEmitter<boolean>();
    this.percent = 0;
  }
  /**
   * Initializes the screen and controls its graphical element
   * @returns void
   */
  public ngOnInit(): void {
    let counter: number = SPLASH_SETTINGS.counterInit;
    const interval = setInterval(() => {
      counter += SPLASH_SETTINGS.count;
      if (counter > SPLASH_SETTINGS.limit) {
        this.loadingComplete.emit(false);
        clearInterval(interval);
      } else {
        this.percent += SPLASH_SETTINGS.count;
      }
    }, SPLASH_SETTINGS.interval);
  }
  /**
   * Method to destroy the data.
   * @returns void
   */
  public ngOnDestroy(): void {
    this.router.navigate(['/home']);
  }
}
